
import React from 'react';
import { Input } from "@/components/ui/input";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Search } from 'lucide-react';

interface AuditTriggerFilterProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
  searchTerm: string;
  setSearchTerm: (value: string) => void;
}

export const AuditTriggerFilter: React.FC<AuditTriggerFilterProps> = ({ 
  activeTab, 
  setActiveTab, 
  searchTerm, 
  setSearchTerm 
}) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <TabsList>
        <TabsTrigger value="all">All Triggers</TabsTrigger>
        <TabsTrigger value="regulatory">Regulatory</TabsTrigger>
        <TabsTrigger value="financial">Financial</TabsTrigger>
        <TabsTrigger value="data">Data Quality</TabsTrigger>
        <TabsTrigger value="governance">Governance</TabsTrigger>
      </TabsList>
      <div className="relative w-[300px]">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
        <Input
          placeholder="Search audit triggers..."
          className="pl-9"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
    </div>
  );
};
